<!-- <div *ngIf="!projects">
  <app-spinner></app-spinner>
</div> -->
<!-- <app-spinner
disable="false"
[text]="['']"
header="Henter prosjekter..."
*ngIf="
  !projects
"
></app-spinner> -->
<app-spinner disable="true" [text]="['Åpner prosjekt...']" [header]="selectedProject.no + ' - ' + selectedProject.name"
             *ngIf="selectedProject"></app-spinner>
<div class="row" *ngIf="!projects" style="margin-top: 50px">
  <div class="fill-space"></div>
  <div>
    <div class="row">
      <div class="fill-space"></div>
      <mat-spinner diameter="55"></mat-spinner>
      <div class="fill-space"></div>
    </div>
    <h3>Henter prosjekter...</h3>
  </div>
  <div class="fill-space"></div>
</div>
<div class="row child-margin" *ngIf="projects">
  <div *ngIf="!mobileQuery.matches" class="fill-space"></div>
  <div class="maxwidth child-margin" *ngIf="projects"
       [style.margin-bottom]="mobileQuery.matches ? '100px' : '0'">
    <!-- <h2 style="text-align: center" *ngIf="projects">
      <mat-icon style="vertical-align: text-top">announcement</mat-icon>
      Ingen prosjekter tilgjengelig
    </h2> -->
    <div>
      <div class="project-card" *ngFor="let p of projects">
        <div class="project-title">
          <p-tag
            [style]="{'border-radius': '15px', 'background': '#398e3c', 'color': '#cacaca', 'font-weight': '200', 'font-size': '20px', 'margin-right': '5px', 'margin-bottom': '5px'}"
            [value]="p.id"
            [severity]="'info'"
          ></p-tag>
          {{ p.name }}<span *ngIf="p.id !== p.no"> (avvik i prosjektinfo)</span>
        </div>
        <!--        <mat-divider style="margin-top: -5px; margin-bottom: 5px;"></mat-divider>-->
        <div class="project-card-row">
          <button mat-raised-button class="hover project-btn project-main-btn flex-center" [routerLink]="p.url"
                  (click)="projectClicked(p)">
            <mat-icon class="icon-style">folder_open</mat-icon>
            <span class="open-label label-style">Åpne</span>
          </button>
          <!-- <button mat-raised-button class="hover project-btn project-object-name-search-btn flex-center"
                  [routerLink]="['/fs', p.id, 'ons']">
            <mat-icon class="icon-style">keyboard</mat-icon>
            <span class="name-search-lbl label-style">Navnesøk</span>
          </button>
          <button mat-raised-button class="hover project-btn project-object-qr-search-btn flex-center"
                  [routerLink]="['/fs', p.id, 'oqs']">
            <mat-icon class="icon-style">qr_code_scanner</mat-icon>
            <span class="qr-search-lbl label-style">QR-søk</span>
          </button> -->
          <button mat-raised-button class="hover project-btn project-object-qr-search-btn flex-center"
                  [routerLink]="['/fs', p.id, 'os']">
            <mat-icon class="icon-style">search</mat-icon>
            <span class="qr-search-lbl label-style">Objektsøk</span>
          </button>
        </div>
      </div>
    </div>
    <div class="row" style="margin-top: 40px;">
      <div class="fill-space"></div>
      <div>
        <img src="assets/logo/aventilogo.svg" alt="Aventi Logo" style="width: 100px; height: auto;">
      </div>
      <div class="fill-space"></div>
    </div>
  </div>
  <div *ngIf="!mobileQuery.matches" class="fill-space"></div>
</div>
